import styled, { css } from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const PlayerInboxWrapper = styled.div`
  position: relative;
  color: black;
  height: calc(100% - 60px);
`

export const PlayerInboxHeader = styled.div`
  position: fixed;
  top: 51px;
  left: 0;
  width: 100%;
  background: ${themeStyles.colors.white.main};
  display: flex;
  z-index: 1;
`

export const PlayerInboxButton = styled.button`
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-progress-appearance: none;
  width: 50%;
  padding: 1rem 0.2rem;
  color: ${themeStyles.colors.black.main};
  background-color: ${themeStyles.colors.white.main};
  border-bottom: 2px solid transparent;
  /* font-size: 0.9em; */

  ${({ isActive }) =>
    isActive &&
    css`
      border-color: ${themeStyles.colors.primary.main};
    `}

  ${themeMedia.tablet`
    font-size: 1em;
  `}
`

export const PlayerInboxBody = styled.div`
  margin-top: calc(48px + 0.2rem);
  background: ${themeStyles.colors.lightGreys[1].main};

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 100%;
    `}

  ${themeMedia.tablet`
    margin-top: calc(50px + 0.2rem);
  `}
`

export const PlayerInboxFooter = styled.div`
  background: ${themeStyles.colors.white.main};
  padding: 1rem;
`
